(ns dre.components.icon
  (:require
    ["@fortawesome/react-fontawesome" :refer [FontAwesomeIcon]]
    ["@fortawesome/free-solid-svg-icons" :refer
     ; Please keep this in alphabetic order
     [faAnglesUp
      faArrowUp
      faArrowUpRightFromSquare 
      faCamera
      faCheck
      faChevronCircleLeft
      faChevronDown
      faChevronLeft
      faChevronRight
      faCircle
      faCircleNodes
      faCircleQuestion
      faClock
      faCode
      faComment
      faCopy
      faDiagramProject
      faDownload
      faEllipsisV
      faEraser
      faEye
      faFileExport
      faFileLines
      faFilter
      faFlask
      faFloppyDisk
      faGear
      faGlobe
      faHashtag
      faInbox
      faIndent
      faIndustry
      faLevelUp
      faLink
      faList
      faLocationDot
      faMagic
      faMagnifyingGlass
      faMagnifyingGlassPlus
      faMinus
      faPencil
      faPenToSquare
      faRss
      faSitemap
      faSpinner
      faTable
      faThumbtack
      faThumbsUp
      faThumbsDown
      faTrashCan
      faTriangleExclamation
      faUmbrella
      faUser
      faUserDoctor
      faUserGroup
      faUsers
      faWandMagicSparkles
      faXmark]]))

(defn svg
  [icon-stack sprite-name]
  [:svg
   {:class (str "icon" "-" (name icon-stack) "-" (name sprite-name))}
   [:use
    {:href (str "/icons/"
                (name icon-stack)
                ".svg#"
                (name sprite-name))}]])

(defn icon
  [icon-stack sprite-name]
  [:div.icon
   [svg icon-stack sprite-name]])

; TODO: this is hacky but I didn't wanted to add all icons and I didn't want to
;       spend too much time to set up dynamic importing with babel
(def ->fa-icon-component
  ; Please keep this in alphabetic order
  {:angles-up faAnglesUp
   :arrow-up faArrowUp
   :camera faCamera
   :check faCheck
   :chevron-down faChevronDown
   :chevron-left faChevronLeft
   :chevron-right faChevronRight
   :chevron-circle-left faChevronCircleLeft 
   :circle faCircle
   :circle-nodes faCircleNodes
   :circle-question faCircleQuestion
   :clock faClock
   :code faCode
   :comment faComment
   :copy faCopy
   :diagram-project faDiagramProject
   :download faDownload
   :ellipsis-v faEllipsisV
   :eraser faEraser
   :external-link faArrowUpRightFromSquare
   :eye faEye
   :file-export faFileExport
   :file-lines faFileLines
   :filter faFilter
   :flask faFlask
   :globe faGlobe
   :hashtag faHashtag
   :inbox faInbox
   :indent faIndent
   :industry faIndustry
   :level-up faLevelUp
   :link faLink
   :list faList
   :location-dot faLocationDot
   :magic faMagic
   :magnifying-glass faMagnifyingGlass
   :magnifying-glass-plus faMagnifyingGlassPlus
   :minus faMinus
   :pencil faPencil
   :pen-to-square faPenToSquare
   :rss faRss
   :settings faGear
   :sitemap faSitemap
   :spinner faSpinner
   :table faTable
   :thumbtack faThumbtack
   :thumbs-up faThumbsUp
   :thumbs-down faThumbsDown
   :trash-can faTrashCan
   :umbrella faUmbrella
   :user faUser
   :user-doctor faUserDoctor
   :user-group faUserGroup
   :users faUsers
   :warning faTriangleExclamation
   :x-mark faXmark})

(defn fa-icon
  ([icon-name]
   [fa-icon icon-name {}])
  ([icon-name opts]
   [:span
    {:class "icon-fa"}
    [:> FontAwesomeIcon
     (merge
      {:icon (->fa-icon-component icon-name)
       :className (str "icon" "-" (name icon-name))}
      opts)]]))

(def ->pill-fa-icon-component
  ; Please keep this in alphabetic order
  {:fa-clock-o faClock
   :fa-file-text-o faFileLines
   :fa-filter faFilter
   :fa-flask faFlask
   :fa-globe faGlobe
   :fa-hashtag faHashtag
   :fa-inbox faInbox
   :fa-industry faIndustry
   :fa-list faList
   :fa-magic faWandMagicSparkles
   :fa-rss faRss
   :fa-save faFloppyDisk
   :fa-sitemap faSitemap
   :fa-umbrella faUmbrella
   :fa-user faUser
   :fa-user-md faUserDoctor
   :fa-users faUsers
   :fa-warning faTriangleExclamation})

(defn pill-fa-icon
  ([icon-name]
   [pill-fa-icon icon-name {}])
  ([icon-name opts]
   [:span 
    {:class "icon-fa"}
    [:> FontAwesomeIcon
    (merge
     {:icon (->pill-fa-icon-component icon-name)
      :className (str "icon" "-" (name icon-name))}
     opts)]]))
